export const EmployerType = {
  GOVERNMENT: 1,
  NON_GOVERNMENT: 2,
  SELF_OR_NOT_EMPLOYED: 3,
};

export const Constants = {
  MAX_AGE: 100,
  PARAMETER_SUBJECT_SUFFIX: '',
  PARAMETER_PARTNER_SUFFIX: '_2',
  POLICE_CONTRIBUTION_RATE: 0.06,
  ASFA_COMFORTABLE_LIVING_SINGLE: 40391,
  BEFORE_TAX: 'beforeTax',
  AFTER_TAX: 'afterTax',
  MIN_CUSTOM_INVESTMENT_VALUE: 2.5,
  MAX_CUSTOM_INVESTMENT_VALUE: 10,
  MONTHLY: 12,
  ANNUALLY: 1,
  DEFAULT_INSURANCE_PREMIUM: 468,
  DEFAULT_RETIREMENT_AGE: 67,
};
